import { render, staticRenderFns } from "./tier-pricing.vue?vue&type=template&id=5fb4f85e&scoped=true"
import script from "./tier-pricing.vue?vue&type=script&lang=js"
export * from "./tier-pricing.vue?vue&type=script&lang=js"
import style0 from "./tier-pricing.vue?vue&type=style&index=0&id=5fb4f85e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4f85e",
  null
  
)

export default component.exports